module.exports = __webpack_public_path__ + "static/media/pipes.649c03e4.jpg";